import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createCaseType = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation createCaseType($name: String!, $description: String!, $schema: String!, $coreTemplate: Boolean!, $iconSet: String!, $iconCode: String!  ) {
          createCaseType(name: $name, description: $description, schema: $schema, coreTemplate: $coreTemplate, iconSet: $iconSet, iconCode: $iconCode ) { message error id displayName code }
        }`),
      variables: { name: data.name, description: data.description, schema: data.schema, coreTemplate: data.coreTemplate, iconSet: data.iconSet, iconCode: data.iconCode }
    })
  return response.data.createCaseType
}

export const updateCaseType = async (updatedCase) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation updateCaseType($id: Int!, $caseTypeProperties: CaseTypeInput!) {
          updateCaseType(id: $id, caseTypeProperties: $caseTypeProperties) { message error }
        }`),
      variables: { id: updatedCase.id, caseTypeProperties: updatedCase.data }
    })
  return response.data.updateCaseType
}

export const updateExistingCases = async (caseTypeId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation upgradeCaseType($id: Int!) {
          upgradeCaseType(id: $id) { message error }
        }`),
      variables: { id: caseTypeId }
    })
  return response.data.upgradeCaseType
}

export const updateExistingTasks = async (caseTypeId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation upgradeCaseType($id: Int!, $upgradeTasks: Boolean!) {
          upgradeCaseType(id: $id, upgradeTasks: $upgradeTasks) { message error }
        }`),
      variables: { id: caseTypeId, upgradeTasks: true }
    })
  return response.data.upgradeCaseType
}

export const deleteCaseType = async (caseTypeId) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation deleteCaseType($id: Int!) {
          deleteCaseType(id: $id) { error message }
        }
      `),
      variables: { id: caseTypeId }
    }
  )
  return response.data.deleteCaseType
}

export const importAtomicData = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation importAtomicData($caseTypeId: Int!, $fields: [String]!, $primaries: [String]!, $shouldCreate: Boolean!, $shouldUpdate: Boolean!, $importData: String!) {
          importAtomicData(caseTypeId: $caseTypeId, fields: $fields, primaries: $primaries, shouldCreate: $shouldCreate, shouldUpdate: $shouldUpdate, importData: $importData) {
            error message
          }
        }`),
      variables: { caseTypeId: data.caseTypeId, fields: data.fields, primaries: data.primaries, shouldCreate: data.shouldCreate, shouldUpdate: data.shouldUpdate, importData: data.importData }
    }
  )
  return response.data.importAtomicData
}

export const importTabularData = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation importTabularData($caseTypeId: Int!, $table: String!, $tablePrimary: String!, $fields: [String]!, $primaries: [String]!, $shouldCreate: Boolean!, $shouldUpdate: Boolean!, $importData: String!) {
          importTabularData(caseTypeId: $caseTypeId, table: $table, tablePrimary: $tablePrimary, fields: $fields, primaries: $primaries, shouldCreate: $shouldCreate, shouldUpdate: $shouldUpdate, importData: $importData) {
            error message
          }
        }`),
      variables: { caseTypeId: data.caseTypeId, table: data.table, tablePrimary: data.tablePrimary, fields: data.fields, primaries: data.primaries, shouldCreate: data.shouldCreate, shouldUpdate: data.shouldUpdate, importData: data.importData }
    }
  )
  return response.data.importTabularData
}

export const reindexDocuments = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation reindexDocuments($dropExistingIndex: Boolean!, $caseTypeId: Int) {
          reindexDocuments(dropExistingIndex: $dropExistingIndex, caseTypeId: $caseTypeId) {
            error
            message
            job { id jobType jobStatus }
          }
        }`),
      variables: {
        dropExistingIndex: data && data.dropExistingIndex !== undefined ? data.dropExistingIndex : true,
        caseTypeId: data && data.caseTypeId ? data.caseTypeId : null
      }
    }
  )
  return response.data.reindexDocuments
}

export const reindexCaseType = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation reindexCaseType($caseTypeId: Int!, $dropExistingIndex: Boolean!) {
          reindexCaseType(caseTypeId: $caseTypeId, dropExistingIndex: $dropExistingIndex) {
            error
            message
            job { id jobType jobStatus }
          }
        }`),
      variables: {
        caseTypeId: data.caseTypeId,
        dropExistingIndex: data && data.dropExistingIndex !== undefined ? data.dropExistingIndex : true
      }
    }
  )
  return response.data.reindexCaseType
}
